import { render } from "./PreviewStudyQuestions.vue?vue&type=template&id=4fec7103&scoped=true"
import script from "./PreviewStudyQuestions.vue?vue&type=script&lang=js"
export * from "./PreviewStudyQuestions.vue?vue&type=script&lang=js"

import "./PreviewStudyQuestions.vue?vue&type=style&index=0&id=4fec7103&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec7103"]])

export default __exports__